<template>
  <app-page title="Check Product">
    <div>
      <v-ons-list>
        <v-ons-list-header>Enter product</v-ons-list-header>
        <v-ons-list-item>
          <div class="center">
            <v-ons-input disable-auto-styling
              input-id="product"
              placeholder="Product"
              v-model="eanInput"
              @keyup.enter="lookup"
              @keyup.tab="lookup"/>
          </div>
          <div class="right">
            <v-ons-progress-circular indeterminate v-if="loading"/>
          </div>
        </v-ons-list-item>
      </v-ons-list>
      <v-ons-list v-if="product">
        <v-ons-list-header>Product information</v-ons-list-header>
        <v-ons-list-item>
          <div class="center label">EAN</div>
          <div class="right">{{product.ean}}</div>
        </v-ons-list-item>
        <v-ons-list-item v-if="product.foreignId">
          <div class="center label">Article</div>
          <div class="right">{{product.foreignId}}</div>
        </v-ons-list-item>                
        <v-ons-list-item>
          <div class="center label">Name</div>
          <div class="right">{{product.productName}}</div>
        </v-ons-list-item>                
        <v-ons-list-item>
          <div class="center label">Location</div>
          <div class="right">{{product.location?product.location.name:""}}</div>
        </v-ons-list-item>                
        <v-ons-list-item v-for="f in dataFields" :key="f.name">
          <div class="center label">{{f.displayName}}</div>
          <div class="right">{{fieldValue(f)}}</div>
        </v-ons-list-item>
      </v-ons-list>
    </div>
  </app-page>
</template>

<script>
import util from "../util.js";
export default {
  data() {
    return {
      eanInput: "",
      product: null,
      loading: false,
      dataFields: []
    };
  },

  mounted() {
    document.addEventListener("click", this.focus);
    this.loadDisplayFields();
    this.load();
  },
  beforeDestroy() {
    document.removeEventListener("click", this.focus);
  },

  watch: { "$route": "load" },

  methods: {

    focus() {
      util.focus("product");
    },

    lookup(evt) {
      evt.preventDefault();
      if (this.eanInput) {
        this.$router.push(`/product/${this.eanInput}`);
      }
    },

    async loadDisplayFields() {
      try {
        const fields = await this.$api.getDisplayFields();
        this.dataFields = Object.values(fields).map(a => a[0]);
      } catch (e) {
        util.error(this, "Failed to load display fields.", e);
      }
    },

    async load() {
      this.eanInput = "";
      const ean = this.$route.params.id;
      if (!ean) {
        this.focus();
        this.loading = false;
        this.product = null;
        return;
      }
      this.loading = true;
      try {
        const product = await this.$api.getProductByEan(ean);
        if (product !== null) {
          if (product.locationId) {
            product.location = await this.$api.getLocation(product.locationId);
          }
          this.product = product;
        } else {
          await util.warn(this, `Product ${ean} not found.`);
        }
      } catch (e) {
        await util.error(this, "Failed to get product details.", e);
      } finally {
        this.loading = false;
      }
    },

    fieldValue(field) {
      const value = this.product.data[field.name];
      if (field.units && field.units.length) {
        const unit = this.product.data[field.name + "_UNIT"];
        if (unit) {
          for (let u of field.units) {
            if (u.name === unit) {
              return value + " " + u.displayName;
            }
          }
          return value + " " + unit;
        }
      }
      return value;
    },
  }
};
</script>

<style scoped>
.label {
  font-weight: bold;
}
.list--material {
  border-bottom: solid 1px lightgray;
}
.list-header--material {
  background: #efeff4;
  text-transform: uppercase;
  line-height: normal;
  border-bottom: solid 1px lightgray;
}
</style>



// WEBPACK FOOTER //
// src/pages/ProductPage.vue